import { ViewListOutlined } from "@mui/icons-material";
import {
    Box,
    Button,
    Container,
    CssBaseline,
    ThemeProvider,
    Typography,
    createTheme,
} from "@mui/material";
import React from "react";

import { account1 } from "../../services/bankAccountData";


const files = [
    "https://eventos.cibnor.mx/registro/apiServiciosSIARF/PDFDocuments/7462267355084253-1.pdf",
    "https://eventos.cibnor.mx/registro/apiServiciosSIARF/PDFDocuments/7462267390995166-2.pdf",
    "https://eventos.cibnor.mx/registro/apiServiciosSIARF/PDFDocuments/7462267508917078-3.pdf",
]
export const Testing = () => {

/**
     function download_files(files) {
  function download_next(i) {
    if (i >= files.length) {
      return;
    }
    var a = document.createElement('a');
    a.href = files[i].download;
    a.target = '_parent';
    // Use a.download if available, it prevents plugins from opening.
    if ('download' in a) {
      a.download = files[i].filename;
    }
    // Add a to the doc for click to work.
    (document.body || document.documentElement).appendChild(a);
    if (a.click) {
      a.click(); // The click method is supported by most browsers.
    } else {
      $(a).click(); // Backup using jquery
    }
    // Delete the temporary link.
    a.parentNode.removeChild(a);
    // Download the next file with a small timeout. The timeout is necessary
    // for IE, which will otherwise only download the first file.
    setTimeout(function() {
      download_next(i + 1);
    }, 500);
  }
  // Initiate the first download.
  download_next(0);
} 
*/

    async function download_files(files) {
        

    } 

    const descargaPressed = () => {
        console.log('aqui');
        download_files(files);
        // const bank = bankAccountData();
        console.log(account1);
    }

    return (
        <ThemeProvider theme={createTheme()}>
            <Container component="main" maxWidth="sm">
                <CssBaseline />
                <Box
                    sx={{
                        mt: 6,
                        mb: 8,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <Typography variant="h6">
                        Demo descarga simultanea en Zip
                    </Typography>

                    <Button
                        variant="outlined"
                        onClick={ () => descargaPressed() }
                        sx={{ mx: 1 }}
                    >
                        <ViewListOutlined /> Descargar
                    </Button>
                </Box>
            </Container>
        </ThemeProvider>
    );
};
